export async function digest(message = '', algorithm = 'SHA-256') {
    const messageUint8 = new TextEncoder().encode(message);
    const hashBuffer = await globalThis.crypto.subtle.digest(algorithm, messageUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}
